import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import type { NotificationEvent } from '@cardapio-online/notifications';

@Component({
  selector: 'lib-ui-notification-item',
  templateUrl: './ui-notification-item.component.html',
  styleUrl: './ui-notification-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiNotificationItemComponent {
  @Input({ required: true }) notification!: NotificationEvent;
  @Input() compact = false;

  protected get timestampLabel(): string {
    return new Intl.DateTimeFormat('pt-BR', {
      dateStyle: 'short',
      timeStyle: 'short',
    }).format(new Date(this.notification.createdAt));
  }
}
